import { apiClient } from '@/api/client'
import type { ApiSuccessResponse, PaginationMeta } from '@/types/api'

export interface AllCandidatesRow {
  studentProfileId: number
  name: string | null
  email: string | null
  mobile: string | null
  program: string
  currentCity: string | null
  currentState: string | null
  highestEducation: string | null
  skills: string[]
  skillCount: number
  totalExperienceMonths: number | null
  isFresher: boolean
  currentCompany: string | null
  currentDesignation: string | null
  category: string | null
  noticePeriodDays: number | null
  profileCompletionPercent: number
  hasResume: boolean
  updatedAt: string | null
  isStarred: boolean
}

export type AllCandidatesSortKey = 'name' | 'location' | 'experience' | 'notice' | 'completion' | 'updated'

export interface AllCandidatesParams {
  search?: string
  name?: string
  email?: string
  mobile?: string
  location?: string
  program?: string
  education?: string
  skills?: string
  company?: string
  designation?: string
  category?: string
  experience_min_months?: number
  experience_max_months?: number
  notice_period_max_days?: number
  has_resume?: 0 | 1
  starred?: 1
  sort?: AllCandidatesSortKey
  direction?: 'asc' | 'desc'
  page?: number
  per_page?: number
}

export interface AllCandidatesFilterOptions {
  programs: { value: string; label: string }[]
  categories: string[]
}

export const allCandidatesApi = {
  list: async (params: AllCandidatesParams) => {
    const { data } = await apiClient.get<
      ApiSuccessResponse<AllCandidatesRow[]> & { meta: PaginationMeta }
    >('/recruiter/candidates/all', { params })
    return { rows: data.data, meta: data.meta }
  },

  setStarred: async (studentProfileId: number, starred: boolean) => {
    const url = `/recruiter/candidates/${studentProfileId}/star`
    if (starred) {
      await apiClient.put(url)
    } else {
      await apiClient.delete(url)
    }
  },

  filterOptions: async () => {
    const { data } = await apiClient.get<ApiSuccessResponse<AllCandidatesFilterOptions>>(
      '/recruiter/candidates/all/filter-options',
    )
    return data.data
  },
}
